module.exports = __webpack_public_path__ + "static/media/Transfat.6a207190.png";